/**
 * 云服务类别 产品图表页 react-grid-layout拖动层
 *
 * @format
 */

import React, { useState, useEffect, FC, useMemo } from 'react'
import styled from 'styled-components'
import { Select, Option, Row, Col, _$ } from '@king-design/react'
import MonitorChartItem from './MonitorChartItem'

const MonitorChartCollapse: FC<any> = ({
  className,
  productType,
  graphs,
  appId,
  tagOpts,
  rangeDate,
  instanceId,
  mointorClassValue,
  openDetails
}) => {
  const [tags, setTags] = useState<string[]>([])

  useEffect(() => {
    setTags(tagOpts?.length > 3 ? [tagOpts[0]] : [])
  }, [tagOpts])

  const filterGraph = useMemo(() => {
    if (tags?.length) {
      const graphFilter = graphs.map(item => {
        return {
          ...item,
          lines: item.lines.filter(line => {
            return line.metricType !== 1 || tags.includes(line.tags?.p1)
          })
        }
      })
      return graphFilter.filter(item => item.lines?.length)
    } else {
      return graphs
    }
  }, [graphs, tags])

  return (
    <div className={className}>
      {tagOpts?.length ? (
        <div className="tag_select">
          <span>{_$('维度')}：</span>
          <Select
            style={{ width: 500 }}
            value={tags}
            placeholder={_$('默认全部维度')}
            multiple
            clearable
            nowrap
            onChangeValue={value => setTags(value)}
          >
            {tagOpts.map(tag => (
              <Option key={tag} value={tag}>
                {tag}
              </Option>
            ))}
          </Select>
        </div>
      ) : null}
      {graphs.length > 0 ? (
        <Row>
          {filterGraph.map((item, index) => {
            return (
              <Col span="12" xxl="8" key={`${item.graphId?.toString()}-${item.title}`}>
                <MonitorChartItem
                  productType={productType}
                  graph={item}
                  rangeDate={rangeDate}
                  instanceId={instanceId}
                  isRequest={mointorClassValue?.includes(appId)}
                  openDetails={data => {
                    openDetails(data, tags)
                  }}
                ></MonitorChartItem>
              </Col>
            )
          })}
        </Row>
      ) : null}
    </div>
  )
}
export default styled(MonitorChartCollapse)`
  padding: 0 8px;
  .tag_select {
    margin: 16px 0 0 16px;
  }
  .k-col {
    padding: 8px;
  }
`
